import { useMemo } from 'react';
import { FONTS_PAIRS, FONT_STYLES } from '@bridebook/web/lib/wedding-website/constants/themes';
import useDynamicFontLink from '@bridebook/web/lib/wedding-website/hooks/use-dynamic-font-link';
import { FontPairs, Palettes } from '@bridebook/web/lib/wedding-website/types';
import {
  IThemedComponentStyles,
  getThemedComponentStyles,
} from '@bridebook/web/lib/wedding-website/utils/get-themed-component-styles';

type TThemeComponentStyles =
  | {
      loading: true;
      styles: undefined;
    }
  | { loading: false; styles: IThemedComponentStyles };

export const useThemedComponentStyles = (
  palette: Palettes = Palettes.Bridebook,
  fontPair: FontPairs = FontPairs.Bridebook,
): TThemeComponentStyles => {
  const { primary: primaryFont, secondary: secondaryFont } = FONTS_PAIRS[fontPair];
  const primaryFontLoaded = useDynamicFontLink(
    FONT_STYLES[primaryFont].fontFamily,
    FONT_STYLES[primaryFont].fontUrl,
  );
  const secondaryFontLoaded = useDynamicFontLink(
    FONT_STYLES[secondaryFont].fontFamily,
    FONT_STYLES[secondaryFont].fontUrl,
  );

  const loading = !primaryFontLoaded && !secondaryFontLoaded;

  const styles = useMemo(() => {
    if (loading) return;
    return getThemedComponentStyles({ primaryFont, secondaryFont, palette });
  }, [loading, palette, primaryFont, secondaryFont]);

  if (loading) {
    return {
      loading,
      styles: undefined,
    };
  }

  return {
    loading,
    styles: styles as IThemedComponentStyles,
  };
};
